import React, { Component } from 'react';
import {
  List,
  Dropdown,
  Divider,
  Icon,
  Input,
  Checkbox
} from 'semantic-ui-react';

import './CampaignList.css';

class CampaignList extends Component {
  handleCampaignValueChange = (event, { id, name, value }) => {
    this.props.changeCampaignValue(id, name, value);
  };

  removeCampaign = (id) => {
    this.props.removeCampaign(id);
  };

  render() {
    return (
      <div>
        {this.props.campaigns.map((campaign) => (
          <div>
            <Checkbox
              label="HEC Campaign"
              name={'is_hec_campaign'}
              id={campaign.id}
              value={campaign.is_hec_campaign}
              checked={campaign.is_hec_campaign}
              onChange={this.handleCampaignValueChange}
            />
            <List.Item>
              <div className="campaign-item-container">
                {campaign.name}
                <a
                  role="button"
                  tabIndex={0}
                  className="campaign-item-remove-link"
                  onClick={() => this.removeCampaign(campaign.id)}
                >
                  <Icon size="large" name="cancel" />
                </a>
                <Divider hidden />
                <Input
                  placeholder="Name"
                  name={'name'}
                  type="text"
                  id={campaign.id}
                  value={campaign.name}
                  onChange={this.handleCampaignValueChange}
                />
                <Divider hidden />
                <Dropdown
                  disabled
                  selection
                  placeholder="Objective"
                  name={'objective'}
                  search
                  id={campaign.id}
                  value={campaign.objective}
                  options={this.props.objectiveOptions}
                  onChange={this.handleCampaignValueChange}
                />
                <Divider hidden />
                <Input
                  placeholder="Tags"
                  name={'tags'}
                  type="text"
                  id={campaign.id}
                  value={campaign.tags}
                  onChange={this.handleCampaignValueChange}
                />
                <Divider hidden />
              </div>
            </List.Item>
          </div>
        ))}
      </div>
    );
  }
}

export default CampaignList;



// WEBPACK FOOTER //
// ./src/screens/PackageBuilder/CampaignList.js